var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"8vh"}},[_c('div',{staticClass:"text-h5 text-bold text-center q-my-lg"},[_vm._v(" "+_vm._s(_vm.userProfile.nickname)+"，你好！ 感谢参与 "),_c('span',{staticClass:"text-primary"},[_vm._v(" 浙江省小微企业调查 2021 ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }